module.exports = __webpack_public_path__ + "static/media/file-music.f23148aa.svg";